import React from 'react';
import cx from 'classnames';
import s from './Loader.module.css';

export function Loader({ variant = 'dark' }) {
    return (
        <div className={cx(s.loaderWrapper, s[variant])}>
            <div className={s.spinner}>
                <div className={s.bounce1}></div>
                <div className={s.bounce2}></div>
                <div className={s.bounce3}></div>
            </div>
        </div>
    );
}
